
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 8.00003L10 13L15 8.00003","fill":"#302936"}}),_c('path',{attrs:{"d":"M5 8.00003L10 13L15 8.00003L5 8.00003Z","stroke":"#302936","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    